// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldStyle } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { alphabetNavigationStyles } from "@pace/Overrides/Widgets/Brand/AlphabetNavigation";
import IconSearch from "@pace/XDL/Icons/IconSearch";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@pace/XDL/Utilities";
import { css } from "styled-components";

alphabetNavigationStyles.container = {
    css: css`
        padding: 24px;
        background: ${color("common.ui11")};
        border-radius: 4px;
        ${xScreen("lte", "md")} {
            padding: 16px;
        }
    `,
};

alphabetNavigationStyles.brandsLettersWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        ${xScreen("lte", "md")} {
            flex-direction: column;
            gap: 16px;
        }
    `,
};

alphabetNavigationStyles.selectWrapper = {
    css: css`
        display: none;
        ${xScreen("lte", "md")} {
            display: flex;
            flex: 1;
        }
    `,
};

alphabetNavigationStyles.alphabetSection = {
    css: css`
        display: flex;
        flex: 1;
        flex-direction: column;
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

alphabetNavigationStyles.alphabetContainer = {
    css: css`
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    `,
};

alphabetNavigationStyles.filterSection = {
    css: css`
        display: flex;
        flex: 1;
        ${FormFieldStyle} {
            max-width: 430px;
            input {
                height: 34px;
            }
        }
    `,
};

alphabetNavigationStyles.filterInput = {
    cssOverrides: {
        formField: css`
            width: 400px;
            ${IconWrapper} {
                top: 10px;
                right: 13px;
                width: 15px;
                height: 15px;
                padding: 0;
            }
            ${xScreen("lte", "md")} {
                &&& {
                    width: 100%;
                    max-width: 100%;
                }
            }
        `,
    },
    iconProps: {
        src: IconSearch,
        color: "text.link",
    },
    labelProps: {
        size: 18,
        weight: fontConfig.weight.bold,
        css: css`
            margin-bottom: 4px;
            &&& {
                line-height: 22px;
            }
            ${xScreen("lte", "md")} {
                font-size: 12px;
                line-height: 17px;
                margin-bottom: 0;
            }
        `,
    },
};

alphabetNavigationStyles.navigationItem = {
    css: css`
        flex: 0 0 auto;
        display: flex;
        margin: 0;
    `,
};

alphabetNavigationStyles.titleText = {
    variant: "h5",
    forwardAs: "h2"
};

alphabetNavigationStyles.navigationLink = {
    ...mergeWithCss(alphabetNavigationStyles.navigationLink, {
        typographyProps: {
            transform: "capitalize",
            lineHeight: "26px",
            size: 16,
        },
        css: css`
            ${TypographyStyle} {
                color: ${({ selectedLetter, disabled }: any) =>
                    selectedLetter ? color("primary") : disabled ? color("text.ui12") : color("text.link")};
            }
        `,
    }),
};
